/* eslint-disable */
export default {
    tour_home_home_title: "Home",
    tour_home_request_assessment_description: "This allows you to immediately start inviting a participant",
    tour_home_request_assessment_title: "Request assessment",
    tour_home_search_participant_description: "Start searching for a participant immediately",
    tour_home_search_participant_title: "Search participant",
    tour_home_organisations_description: "Want to create or alter certain settings? You access them all via the organisation settings ",
    tour_home_organisations_title: "Organisation settings",
    tour_home_create_profile_description: "New vacancy? Create a profile immediately to select the right participant",
    tour_home_create_profile_title: "Create a profile",
    tour_home_home_description: "This is where you always start on our platform. Here you will see the most recently available reports",
    tour_next: "Next",
    tour_previous: "Previous",
    tour_done: "Done"
};
